import React, { useEffect, useState } from 'react';
import { Box, Typography, TextField, Checkbox, FormControlLabel, Link } from '@material-ui/core';
import CustomModal from '../../eir-porting/CustomModal/CustomModal';
import useStyles from './style';
import { useApolloClient } from '@apollo/client';
import { useWindowDimension } from '../../../hooks/windowDimensions';
import EirButton from '../../../theme/EirButton';
import ESIMActivationModal from './ESIMActivationModal';
import { handleSimReplacement } from './simReplacement.util';
import { Alert, AlertTitle } from '@material-ui/lab';
import { useHistory } from 'react-router-dom';
import MyEirErrorHandle from '../../eir-porting/MyEirErrorHandle';

const EsimReplacementModal = ({
    showESIMReplacementModal,
    setshowESIMReplacementModal,
    simCardType,
    setcloseOrderSimModal,
    serviceId,
}) => {
    const classes = useStyles();
    const graphql = useApolloClient();
    const [open, setOpenModal] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [showActivationModal, setshowActivationModal] = useState(false);
    const backArrowAction = () => {
        setOpenModal(!open);
        setshowESIMReplacementModal(false);
        setshowActivationModal(false);
    };
    const [cta1, setCTA1] = useState({ text: '', action: () => {}, disable: false });
    const [cta2, setCTA2] = useState({ text: '', action: () => {}, disable: false });
    const [agreed, setAgreed] = useState(false);
    const [width, height] = useWindowDimension();
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const handleCheckboxChange = event => {
        const checked = event.target.checked;
        setAgreed(checked);
    };

    const user = sessionStorage.getItem('LoggedinUser');
    const handleOpen = () => {
        setOpenModal(true);
    };
    const submitSimReplacement = async () => {
        setIsLoading(true);
        const response = await handleSimReplacement({ graphql, serviceId });
        if (response) {
            setIsLoading(false);
            setshowActivationModal(true);
        } else {
            setIsLoading(false);
            setOpenError(true);
        }
    };
    useEffect(() => {
        showESIMReplacementModal && handleOpen();
    }, [showESIMReplacementModal]);

    useEffect(() => {
        showActivationModal && handleOpen();
    }, [showActivationModal]);

    return (
        <>
            <Box id='sim-replacement'>
                {/* <Typography  onClick={handleOpen} className={classes.simLink}>
                
            </Typography> */}
                <CustomModal
                    open={open}
                    toggle={backArrowAction}
                    header={{
                        text:
                            simCardType === 'ESIM'
                                ? 'eSIM replacement'
                                : 'Confirm eSIM replacement',
                        arrowAction: backArrowAction,
                        center: false,
                        ariaLabel: 'Go to previous page',
                    }}
                    cta1={cta1}
                    cta2={cta2}
                >
                    <Box className={classes.esimReplacementContent}>
                        {simCardType === 'ALL_IN_1' && (
                            <Alert severity='info' className={classes.alertBox}>
                                <AlertTitle className={classes.alertTitleText}>
                                    <Typography variant='body2'>
                                        Please ensure your device is eSIM compatible.
                                    </Typography>
                                </AlertTitle>
                            </Alert>
                        )}

                        <Typography variant='body1' className={classes.esimReplacementText}>
                            After confirming your eSIM replacement request, your QR code and
                            passcode will be available here.
                        </Typography>

                        {/* <Typography variant='body1' className={classes.esimReplacementText}>
                            You will also receive an email with your QR code. Please ensure the
                            email address below is correct. If it is incorrect, update it in your{' '}
                            <span
                                className={classes.esimReplacementLink}
                                onClick={() => {
                                    history.push('/account/details');
                                    // toggle();
                                }}
                            >
                                account details
                            </span>{' '}
                            before proceeding.
                        </Typography> */}

                        <Typography variant='body1' className={classes.esimReplacementText}>
                            You will also receive an email when your QR code is ready. Please ensure
                            the email address below is correct. If it is incorrect, please contact
                            us on 1901 to update this.
                        </Typography>

                        <TextField
                            variant='outlined'
                            label='Email'
                            value={user}
                            disabled
                            fullWidth
                            size='small'
                            className={classes.esimReplacementEmailField}
                        />

                        <Typography variant='h6' className={classes.esimReplacementSectionTitle}>
                            Loss of mobile service
                        </Typography>

                        <Typography variant='body1' className={classes.esimReplacementText}>
                            Once you proceed with this eSIM replacement, you will experience a loss
                            of mobile service until the new eSIM is downloaded.
                        </Typography>

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={agreed}
                                    onChange={handleCheckboxChange}
                                    className={classes.esimReplacementCheckbox}
                                    aria-label='Checkbox'
                                />
                            }
                            label='I understand and agree to proceed'
                            className={classes.esimReplacementCheckboxLabel}
                        />
                        <Box
                            style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                flexDirection: 'column',
                                gap: width < 600 ? '22px' : '24px',
                                marginTop: width < 600 ? '0px' : '8px',
                            }}
                        >
                            {width < 600 ? (
                                <EirButton
                                    onClick={submitSimReplacement}
                                    variants='primaryButtonMedium'
                                    style={{ padding: '0.5rem 2.5rem', width: '100%' }}
                                    disabled={!agreed || !isLoading}
                                    role='button'
                                    aria-label='submit'
                                >
                                    Submit
                                </EirButton>
                            ) : (
                                <EirButton
                                    onClick={submitSimReplacement}
                                    variants='primaryButtonMedium'
                                    style={{ padding: '0.5rem 1.438rem' }}
                                    disabled={!agreed}
                                    role='button'
                                    aria-label='submit'
                                >
                                    Submit
                                </EirButton>
                            )}

                            <Link
                                component='a'
                                href='#'
                                variant='h6'
                                className={classes.cancelLink}
                                onClick={backArrowAction}
                                role='link'
                                aria-label='cancel'
                            >
                                Cancel
                            </Link>
                        </Box>
                    </Box>
                </CustomModal>
                {openError ? <MyEirErrorHandle open={openError} setOpen={setOpenError} /> : ''}
            </Box>
            {showActivationModal && (
                <ESIMActivationModal
                    serviceId={serviceId}
                    openActivationModal={showActivationModal}
                    setOpenActivationModal={setshowActivationModal}
                    header={'Activate your  eSIM'}
                    setCloseModal={setOpenModal}
                    setcloseOrderReplaceSimModal={setcloseOrderSimModal}
                />
            )}
        </>
    );
};

export default EsimReplacementModal;
